import gql from "graphql-tag";

export const OCCUPATION_SELECTIONS = gql`
  query occupationSelections {
    currentUnit {
      id
      occupationSelections {
        id
        occupation {
          id
          name
          code
          validFrom
        }
      }
    }
  },
`;
